import React, { Component } from "react";

const MenuIcon = ({ width, height, fill }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 19 4" fill="none">
      <ellipse cx="2" cy="2" rx="2" ry="2" fill="#979797" />
      <ellipse cx="9.2002" cy="2" rx="2" ry="2" fill={fill} />
      <ellipse cx="16.3999" cy="2" rx="2" ry="2" fill={fill} />
    </svg>
  );
};

MenuIcon.defaultProps = {
  width: 19,
  height: 4,
  fill: "#979797",
};

export default MenuIcon;
